import React, { useEffect } from 'react';

import { FlexColumn } from '@editor/components/utilities/layouts';
import {
  PURCHASE_CREDITS_LABEL,
  PURCHASE_SUCCESS,
} from '@editor/global/analytics/events';
import analytics from '@repo/analytics';
import { Button, primaryTheme } from '@repo/ui/components/Buttons';
import { Spacer } from '@repo/ui/components/Spacer';
import { Modal } from '@repo/ui/deprecated/Modal';
import { buildWebsiteUrl } from '@repo/utils/url';

import {
  Wrapper,
  ContentWrapper,
  ImageWrapper,
  Heading,
  Description,
} from './style';

export const PaymentSuccessModal: React.FC<{
  onClose: () => void;
}> = ({ onClose }) => {
  useEffect(() => {
    analytics.track(PURCHASE_SUCCESS, { label: PURCHASE_CREDITS_LABEL });
  }, []);
  return (
    <Modal isOpen height="620px" width="940px" onClose={() => onClose()}>
      <Wrapper>
        <ContentWrapper>
          <FlexColumn>
            <Heading>Payment Successful</Heading>
            <Spacer height="12px" />
            <Description>
              Your payment was successful. You can now enjoy your extra credits.
              Visit the{' '}
              <a href={buildWebsiteUrl('/user/settings/subscription')}>
                Payment & Billing
              </a>{' '}
              page for managing your billing information.
            </Description>

            <Spacer height="24px" />
            <Button
              height="40px"
              label="Start Creating "
              name="paymentSuccessStartCreatingButton"
              theme={{
                ...primaryTheme,
                padding: '12px',
              }}
              onClick={() => onClose()}
            />
          </FlexColumn>
        </ContentWrapper>

        <ImageWrapper background="url(/images/upgrade/PaymentSuccess.png)" />
      </Wrapper>
    </Modal>
  );
};
